<template>
    <div id="app">
        <Header></Header>
        <Breadcrumb name="配装器" slug="pz" root="/pz" :publishEnable="false" :adminEnable="false" :feedbackEnable="true" :crumbEnable="true">
            <img slot="logo" svg-inline :src="getAppIcon('pz')" />
            <template slot="op-append">
                <template v-if="isAdmin">
                    <div class="m-pz-admin" v-if="isSinglePage">
                        <el-button type="primary" class="u-star" :class="{ on: isStar }" :icon="isStar ? 'el-icon-star-on' : 'el-icon-star-off'" size="mini" @click="starSchema">{{
                            starText
                        }}</el-button>
                        <el-button type="danger" class="u-delete" icon="el-icon-delete" size="mini" @click="delSchema">删除</el-button>
                    </div>
                </template>
                <template v-else>
                    <a href="/tool/31141" target="_blank" class="u-feedback u-doc el-button el-button--primary el-button--medium">
                        <i class="el-icon-question"></i>
                        <span>帮助</span>
                    </a>
                </template>
            </template>
        </Breadcrumb>
        <keep-alive include="Mine,Public">
            <router-view></router-view>
        </keep-alive>
    </div>
</template>

<script>
const single_pages = ["view"];
import { removePz, setStar, getGlobalSetting } from "@/service/schema.js";
import User from "@jx3box/jx3box-common/js/user";
import { getAppIcon } from "@jx3box/jx3box-common/js/utils";
export default {
    name: "App",
    props: [],
    data: function() {
        return {
            isAdmin: User.isEditor(),
            isStar: false,
        };
    },
    computed: {
        id: function() {
            return this.$route.params.id;
        },
        isSinglePage: function() {
            return single_pages.includes(this.$route.name);
        },
        starText: function() {
            return this.isStar ? "取消推荐" : "推荐";
        },
    },
    watch: {
        "$store.getters.isStar": function(val) {
            this.isStar = val;
        },
    },
    methods: {
        delSchema: function() {
            this.$confirm(`确认删除该方案？`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                beforeClose: (action, instance, done) => {
                    if (action === "confirm") {
                        instance.confirmButtonLoading = true;
                        removePz(this.id)
                            .then(() => {
                                done();
                                this.$notify({
                                    title: "成功",
                                    message: "删除成功",
                                    type: "success",
                                });
                            })
                            .finally(() => {
                                instance.confirmButtonLoading = false;
                            });
                    } else {
                        done();
                    }
                },
            });
        },
        starSchema: function() {
            const star = Number(!this.isStar);
            setStar(this.id, {
                star,
            }).then((res) => {
                this.$notify({
                    title: "成功",
                    message: "操作成功",
                    type: "success",
                });
                this.isStar = star;
            });
        },
        getAppIcon,
        checkSetting: function() {
            // 自动保存设定
            let cache = sessionStorage.getItem("pz_setting");
            if (!cache) {
                getGlobalSetting().then((res) => {
                    let setting = res.data.data;
                    this.$store.commit("SET_STATE", {
                        key: "setting",
                        value: setting,
                    });
                    sessionStorage.setItem("pz_setting", JSON.stringify(setting));
                });
            } else {
                this.$store.commit("SET_STATE", {
                    key: "setting",
                    value: JSON.parse(cache),
                });
            }
        },
        init: function() {
            if (User.isLogin()) {
                this.checkSetting();
            }
        },
    },
    mounted: function() {
        this.init();
    },
};
</script>

<style lang="less">
@import "./assets/css/app.less";
@import "./assets/css/common.less";
</style>
